import noUiSlider from 'nouislider';
export default class ProductFilters {
    static initElements(filterForm, sortSelector, perPageSelector) {
        if (filterForm !== undefined) {
            this.form = filterForm;
            this.priceStart = document.querySelector('#price-start-value');
            this.priceEnd = document.querySelector('#price-end-value');
            this.priceEnd = document.querySelector('#price-end-value');
            this.priceFilterMin = document.querySelector('#price-filter-min');
            this.priceFilterMax = document.querySelector('#price-filter-max');
            this.priceSelectedMin = document.querySelector('#price-lower-value');
            this.priceSelectedMax = document.querySelector('#price-upper-value');
            this.priceRange = document.querySelector('#price-range');
            this.inShopCheckbox = document.querySelector('#filter_checkbox_shop_available');
            this.selectedShop = document.querySelector('#filter_checkbox_shop_available_id');
        }
        this.sortSelect = sortSelector;
        this.perPageSelector = perPageSelector;
    }
    static initSlider(element) {
        const slider = element;
        let priceStart = 0;
        if (this.priceStart && parseInt(this.priceStart.value)) {
            priceStart = parseInt(this.priceStart.value);
        }
        let priceEnd = 0;
        if (this.priceEnd && parseInt(this.priceEnd.value)) {
            priceEnd = parseInt(this.priceEnd.value);
        }
        let priceRange = {
            min: 0,
            max: 100,
        };
        if (this.priceRange) {
            priceRange = JSON.parse(this.priceRange.value);
        }
        noUiSlider.create(element, {
            start: [priceStart, priceEnd],
            step: 1,
            connect: true,
            range: {
                min: priceRange.min,
                max: priceRange.max,
            },
            format: {
                to: (v) => parseFloat(v).toFixed(0),
                from: (v) => parseFloat(v).toFixed(0),
            },
        });
        const priceFilterMinTxt = this.priceSelectedMin;
        const priceFilterMaxTxt = this.priceSelectedMax;
        slider.noUiSlider.on('update', function (values) {
            priceFilterMinTxt ? (priceFilterMinTxt.innerHTML = values[0]) : 0;
            priceFilterMaxTxt ? (priceFilterMaxTxt.innerHTML = values[1]) : 0;
        });
    }
    static getTargetUrl() {
        const urlData = {};
        if (this.form) {
            this.form.querySelectorAll('.filter-element__item input:checked').forEach((checkbox) => {
                const parent = checkbox.parentNode;
                let tag = undefined;
                if (parent) {
                    tag = parent.querySelector('.filter-element__label');
                }
                const feature = checkbox.closest('.filter-element');
                if (feature) {
                    const featureDataset = feature.dataset;
                    let featureId = null;
                    if (featureDataset.id) {
                        featureId = featureDataset.id;
                    }
                    let featureSeoName = null;
                    if (featureDataset.seoName) {
                        featureSeoName = featureDataset.seoName;
                    }
                    if (featureId && featureSeoName && typeof urlData[featureId] == 'undefined') {
                        urlData[featureId] = {
                            id: featureId,
                            seo_name: featureSeoName,
                            values: {},
                        };
                    }
                    if (tag && featureId) {
                        const tagDataset = tag.dataset;
                        let tagId = null;
                        if (tagDataset.id) {
                            tagId = tagDataset.id;
                        }
                        let tagSeoName = null;
                        if (tagDataset.seoName) {
                            tagSeoName = tagDataset.seoName;
                        }
                        if (tagId && tagSeoName) {
                            urlData[featureId]['values'][tagId] = {
                                id: tagId,
                                seo_name: tagSeoName,
                            };
                        }
                    }
                }
            });
        }
        let urlStr = '';
        for (const i in urlData) {
            if (urlStr != '') {
                urlStr += this.featuresSeparator;
            }
            urlStr += urlData[i]['id'] + this.valuesSeparator + encodeURIComponent(urlData[i]['seo_name']);
            for (const k in urlData[i]['values']) {
                urlStr +=
                    this.valuesSeparator +
                        urlData[i]['values'][k]['id'] +
                        this.valuesSeparator +
                        encodeURIComponent(urlData[i]['values'][k]['seo_name']);
            }
        }
        let sortStr = '';
        if (this.sortSelect) {
            const promoPage = this.sortSelect.dataset.promo;
            const sortValue = this.sortSelect.value;
            if (this.searchEngineMode) {
                sortStr =
                    typeof sortValue !== 'undefined' && sortValue != '4' && sortValue != '5'
                        ? '&sort=' + sortValue
                        : '';
            }
            else {
                sortStr =
                    typeof sortValue !== 'undefined' && (sortValue != '0' || promoPage == '1')
                        ? '/sort/' + sortValue
                        : '';
            }
        }
        let perpageStr = '';
        const perpageValue = this.perPageSelector ? this.perPageSelector.value : '16';
        if (this.searchEngineMode) {
            perpageStr = typeof perpageValue !== 'undefined' && perpageValue != '16' ? '&pp=' + perpageValue : '';
        }
        else {
            perpageStr = typeof perpageValue !== 'undefined' && perpageValue != '16' ? '/pp/' + perpageValue : '';
        }
        // Zakres cenowy
        const priceSelectedMin = this.priceSelectedMin ? this.priceSelectedMin.innerHTML : null;
        const priceSelectedMax = this.priceSelectedMax ? this.priceSelectedMax.innerHTML : null;
        const priceStart = this.priceStart ? this.priceStart.value : null;
        const priceEnd = this.priceEnd ? this.priceEnd.value : null;
        const priceFilterMin = this.priceFilterMin ? this.priceFilterMin.value : null;
        const priceFilterMax = this.priceFilterMax ? this.priceFilterMax.value : null;
        let priceStr = '';
        if (priceSelectedMin && priceSelectedMax && (priceStart != priceSelectedMin || priceEnd != priceSelectedMax)) {
            priceStr = this.priceUrl(priceSelectedMin, priceSelectedMax);
        }
        else if (priceStart &&
            priceEnd &&
            (priceFilterMin !== '0' || priceFilterMax !== '0') &&
            (priceStart != priceFilterMin || priceEnd != priceFilterMax)) {
            priceStr = this.priceUrl(priceStart, priceEnd);
        }
        else if (priceFilterMin && priceFilterMax && (priceFilterMin !== '0' || priceFilterMax !== '0')) {
            priceStr = this.priceUrl(priceFilterMin, priceFilterMax);
        }
        let selectedShopStr = '';
        let availableInShopStr = '';
        if (this.availableInShopFilter) {
            if (this.selectedShop && this.selectedShop.value != '') {
                if (this.searchEngineMode) {
                    selectedShopStr = '&shop=' + this.selectedShop.value;
                }
                else {
                    selectedShopStr = '/shop/' + this.selectedShop.value;
                }
            }
            if (this.inShopCheckbox && this.selectedShop && this.selectedShop.value != '') {
                if (this.inShopCheckbox.checked) {
                    if (this.searchEngineMode) {
                        availableInShopStr = '&is=1';
                    }
                    else {
                        availableInShopStr = '/is/1';
                    }
                }
            }
        }
        let finalLocation = '';
        if (this.searchEngineMode) {
            // Połączenie parametrów GET wyszukiwarki z parametrami filtrów
            if (urlStr != '') {
                urlStr = '&f=' + urlStr;
            }
            // Przeniesienie użytkownika na stronę docelową
            finalLocation =
                this.baseUrl +
                    '?' +
                    this.getParams +
                    urlStr +
                    perpageStr +
                    sortStr +
                    priceStr +
                    availableInShopStr +
                    selectedShopStr;
        }
        else {
            // Przeniesienie użytkownika na stronę docelową
            if (urlStr != '') {
                finalLocation =
                    this.baseUrl +
                        perpageStr +
                        sortStr +
                        '/f/' +
                        urlStr +
                        priceStr +
                        availableInShopStr +
                        selectedShopStr;
            }
            else {
                finalLocation = this.baseUrl + perpageStr + sortStr + priceStr + availableInShopStr + selectedShopStr;
            }
        }
        return finalLocation;
    }
    static priceUrl(min, max) {
        let priceStr = '';
        if (this.searchEngineMode) {
            priceStr = '&p=' + encodeURIComponent(min) + ',' + encodeURIComponent(max);
        }
        else {
            priceStr = '/p/' + encodeURIComponent(min) + ',' + encodeURIComponent(max);
        }
        return priceStr;
    }
    static filter() {
        if (!this.form) {
            return;
        }
        this.form.dispatchEvent(new Event('submit', {
            bubbles: true,
            cancelable: true,
        }));
    }
}
ProductFilters.sortSelect = null;
ProductFilters.priceStart = null;
ProductFilters.priceEnd = null;
ProductFilters.priceFilterMin = null;
ProductFilters.priceFilterMax = null;
ProductFilters.priceSelectedMin = null;
ProductFilters.priceSelectedMax = null;
ProductFilters.priceRange = null;
ProductFilters.perPageSelector = null;
ProductFilters.inShopCheckbox = null;
ProductFilters.selectedShop = null;
ProductFilters.searchEngineMode = false;
ProductFilters.getParams = '';
ProductFilters.availableInShopFilter = false;
